import React from "react";

// Material UI Components
import Input from "@mui/material/Input";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  defaultText: {
    "& .MuiInputBase-input": {
      border: `2px solid ${theme.palette.MDCColors.color23}`,
      background: theme.palette.MDCColors.color21,
      color: theme.palette.MDCColors.color18,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      marginTop: "0.625rem",
      fontSize: "1rem",
      fontFamily: theme.palette.typography.fontFamily,
      padding: "0rem 0.938rem 0rem 0.938rem",
      height: "calc(1rem + 1rem + 0.625rem)",
      borderRadius: "5px",
    },
  },
  errorText: {
    "& .MuiInputBase-input": {
      border: `2px solid ${theme.palette.MDCColors.errorDanger}`,
      background: "rgba(236, 88, 103, 0.3)",
    },
  },
  disabledText: {
    "& .MuiInputBase-input": {
      border: "0px",
      opacity: "0",
    },
  },
}));

function MDCRegisterEmail(props) {
  const {
    name,
    onChange,
    value,
    type,
    error,
    disableUnderline,
    placeholder,
    autoComplete,
    readOnly,
    allowCopyPaste = false,
  } = props;
  // Handle Field Change
  const handleFieldDisable = (e) => {
    e.preventDefault();
    return false;
  };

  const { defaultText, errorText, disabledText } = useStyles();

  let MDCStyles = defaultText;
  if (error) {
    MDCStyles = `${MDCStyles} ${errorText}`;
  }

  if (readOnly) {
    MDCStyles = `${MDCStyles} ${disabledText}`;
  }

  return (
    <div>
      <Input
        fullWidth
        className={MDCStyles}
        onChange={onChange}
        value={value}
        type={type || "text"}
        name={name}
        error={error}
        disableUnderline={disableUnderline}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={readOnly}
        onCopy={!allowCopyPaste ? (e) => handleFieldDisable(e) : undefined}
        onPaste={!allowCopyPaste ? (e) => handleFieldDisable(e) : undefined}
        draggable={false}
        onDragStart={(e) => handleFieldDisable(e)}
        inputProps={{ maxLength: 255 }}
      />
    </div>
  );
}

export default MDCRegisterEmail;
